import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useTheme } from '../../contexts/ThemeContext';

interface DynamicThemeProviderProps {
  children: React.ReactNode;
}

export function DynamicThemeProvider({ children }: DynamicThemeProviderProps) {
  const { theme } = useTheme();

  useEffect(() => {
    // Apply custom CSS variables to document root
    const root = document.documentElement;
    
    // Set CSS custom properties for dynamic styling
    root.style.setProperty('--customer-primary-color', theme.customer.primaryColor);
    root.style.setProperty('--customer-secondary-color', theme.customer.secondaryColor);
    root.style.setProperty('--customer-accent-color', theme.customer.accentColor || theme.customer.secondaryColor);
    root.style.setProperty('--customer-border-radius', `${theme.customer.borderRadius || 8}px`);
    root.style.setProperty('--customer-spacing', `${theme.customer.spacing || 8}px`);
    root.style.setProperty('--customer-font-family', theme.customer.fontFamily || 'Roboto, sans-serif');

    // Apply custom CSS if provided
    if (theme.customer.customCSS) {
      const styleId = 'customer-custom-css';
      let customStyle = document.getElementById(styleId);
      
      if (!customStyle) {
        customStyle = document.createElement('style');
        customStyle.id = styleId;
        document.head.appendChild(customStyle);
      }
      
      customStyle.textContent = theme.customer.customCSS;
    }

    // Update favicon if provided
    if (theme.customer.favicon) {
      const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (favicon) {
        favicon.href = theme.customer.favicon;
      }
    }

    // Note: Page titles are now handled by individual pages/components
    // rather than being automatically changed by the theme system

  }, [theme]);

  return (
    <MuiThemeProvider theme={theme}>
      {children}
    </MuiThemeProvider>
  );
}
